import React, { useState } from "react";
import { Button, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

// Function to convert image URL to base64
const getBase64ImageFromURL = async (url) => {
  const response = await fetch(url);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

const ExportButton = ({ data, columnsConfig }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  // Function to export data to Excel or CSV
  const exportToExcel = (type) => {
    const worksheet = XLSX.utils.json_to_sheet(data); // Convert data to worksheet
    const workbook = XLSX.utils.book_new(); // Create a new workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data"); // Append the worksheet to the workbook

    if (type === "excel") {
      XLSX.writeFile(workbook, "data.xlsx"); // Export to Excel
    } else if (type === "csv") {
      XLSX.writeFile(workbook, "data.csv", { bookType: 'csv' }); // Export to CSV
    }
  };

  // Function to export data to PDF
  const exportToPDF = async () => {
    const doc = new jsPDF();

    // Define the columns (ignoring the image column for table data)
    const columns = columnsConfig.filter(col => !col.isImage).map(col => col.label);

    // Prepare the rows (exclude image base64 data from table rows)
    const rows = await Promise.all(
      data.map((item, index) => {
        return columnsConfig
          .filter(col => !col.isImage) // Exclude image columns from row data
          .map(col => {
            if (col.label === 'S.No') {
              return index + 1; // Handle serial number
            }
            return col.getValue(item);
          });
      })
    );

    // Add the table to the PDF
    doc.autoTable({
      head: [columns],
      body: rows,
      didDrawCell: async (data) => {
        // Add the image in the specific column (assuming profile picture is at index 2)
        if (columnsConfig[data.column.index]?.isImage) {
          const imageUrl = columnsConfig[data.column.index].getValue(data.row.raw);
          const imageBase64 = await getBase64ImageFromURL(imageUrl);
          doc.addImage(imageBase64, 'JPEG', data.cell.x + 2, data.cell.y + 2, 10, 10); // Adjust size and position as needed
        }
      }
    });

    doc.save("data.pdf"); // Save the PDF
  };

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle} className="p-0">
      <DropdownToggle color="success" caret>
        Export
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem onClick={() => exportToExcel("excel")}>Export to Excel</DropdownItem>
        <DropdownItem onClick={() => exportToExcel("csv")}>Export to CSV</DropdownItem>
        <DropdownItem onClick={exportToPDF}>Export to PDF</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default ExportButton;
